const wordpress_graphql = process.env.NEXT_PUBLIC_WORDPRESS_URL + '/graphql'
const strapi_graphql = process.env.NEXT_PUBLIC_STRAPI_URL + '/graphql'

export async function getWordpressGraphqlData<T>(
  query?: string,
  variables?: Record<string, unknown>
): Promise<T> {
  const response = await fetch(wordpress_graphql, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query, variables })
  })
  const result = await response.json()
  return result.data
}

export async function getStrapiGraphqlData<T>(
  query?: string,
  variables?: Record<string, unknown>
): Promise<T> {
  const response = await fetch(strapi_graphql, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query, variables })
  })
  const result = await response.json()
  return result.data
}
